﻿'use strict';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Masonry from 'react-masonry-css';
import ReactMarkdown from "react-markdown/with-html";
import { MediaObject, MediaObjectFigure, ModalCarousel, Picture } from './sharedComponents'
import {formatImage} from './commonhelpers'

export const PhotoAlbum = ({ isAlbum, slug, lazyLoadInstance, url }) => {
  const [dataPath, setDataPath] = useState('')
  const [elements, setElements] = useState([])
  const [isPhotoGrid, setPhotoGrid] = useState(isAlbum)
  const [showModal, setModalVisibility] = useState(false)
  const [selectedPhotoId, setSelectedPhotoId] = useState('')
  const [description, setDescription] = useState('')
  const [headline, setHeadline] = useState('')

  const toggleModal = photo => {
    setModalVisibility(showModal => !showModal)
    photo && setSelectedPhotoId(photo.id)
  };

  const handleOutsideClick = () => {
    setModalVisibility(showModal => !showModal)
  }

  useEffect(() => {
    axios
      .get(slug)
      .then(res => {
        const { elements, description, fields } = res.data;

        const { headline } = fields;

        setDataPath(slug)
        setHeadline(headline)
        setDescription(description)
        setElements(elements)
      })
      .catch(error => {
        console.log(error);
      });
  }, [])

  return (
    <div className="d3-l-grid--outer">
      <div className="d3-l-grid--inner">
        <div className="d3-l-col__col-12">
          {
            isPhotoGrid ? <PhotoView toggleModal={toggleModal} headline={headline} description={description} lazyLoadInstance={lazyLoadInstance} elements={elements} />
              : <LandingView url={url} headline={headline} description={description} lazyLoadInstance={lazyLoadInstance} elements={elements} />
          }
          {
            showModal && <ModalCarousel elements={elements} selectedPhotoId={selectedPhotoId} toggleModal={toggleModal} handleOutsideClick={handleOutsideClick} lazyLoadInstance={lazyLoadInstance} />
          }
        </div>
      </div>
    </div>
  )
}


const LandingView = ({ elements, lazyLoadInstance, url }) => {
  return (
    <div className="d3-c-greatest-photo__landing">
      <div className="d3-c-greatest-photo__background">
        {
          elements.length > 0 &&
          <div className="d3-c-greatest-photo__background-image-container">
            {
              elements
              .filter((item, index) => index < 3)
                .map(photo => {
                  const singleImage = formatImage(photo.image, { format: "t_portrait_mobile", extension: "f_auto" });

                return (
                  <MediaObject
                    className='d3-c-greatest-photo__photo'
                    key={photo._entityId}
                    lazyLoadInstance={lazyLoadInstance}
                    viewType='landing'
                  >
                    <MediaObjectFigure lazyLoadInstance={lazyLoadInstance}>
                      {singleImage &&
                        <Picture isMoment={false} image={singleImage} isLazy={lazyLoadInstance} />}
                    </MediaObjectFigure>
                  </MediaObject>
                )
              })
            }
          </div>
        }
      </div>
      <div className="d3-c-greatest-photo__title-container">
        <div className="d3-c-greatest-photo__title">
          <h2>TOP 100</h2>
          <h2>NFL PHOTOS</h2>
        </div>
        <a className="d3-o-button d3-o-button__landing" href={url}>
          View All
        </a>  
      </div>
    </div>
  )
}

const PhotoView = ({ elements, headline, description, toggleModal, lazyLoadInstance }) => {  
  const breakpointColumnsObj = {
    default: 4,
    1024: 4,
    900: 3,
    767: 2,
    500: 1
  };

  return (
    <div className="d3-c-photo-album__masonry">
        <div className="d3-c-photo-album__title-container">
          <div className="d3-c-photo-album__title">
            <h2>
            <ReactMarkdown
              escapeHtml={false}
              source={headline} />
            </h2>
          </div>
          <div className="d3-c-photo-album__description">
            <ReactMarkdown
              escapeHtml={false}
              source={description} />
          </div>
        </div>
        <Masonry 
          breakpointCols={breakpointColumnsObj}
          className="d3-c-photo-album__masonry-grid"
          columnClassName="d3-c-photo-album__column"
        >
          {
            elements.length > 0 &&
          elements.map(photo => {
            const singleImage = formatImage(photo.image, { format: "w_300,c_scale", extension: "f_auto" });
              return (
                <MediaObject
                  className="d3-c-photo-album__photo"
                  key={photo._entityId}
                  toggleModal={toggleModal}
                  id={photo._entityId}
                  viewType='grid'
                  isMoment={false}
                >
                  <MediaObjectFigure lazyLoadInstance={lazyLoadInstance} >
                    {singleImage &&
                      <Picture isMoment={false} image={singleImage} isLazy={lazyLoadInstance} />}
                  </MediaObjectFigure>

                </MediaObject>
              );
            })
          }
        </Masonry>
    </div>
  )
}
